import Cookies from 'js-cookie';
export function fontSizeChange(fontChangeEl, fontBigEl, fontNormalEl) {
  if ($(fontChangeEl).length && $(fontBigEl).length && $(fontNormalEl).length) {

    const cookieName = "fontSize";

    if(Cookies.get(cookieName) === 'Big') {
      document.querySelector("html").style.fontSize = 120 + "%";
      $(fontNormalEl).removeClass("is-active");
      $(fontBigEl).addClass("is-active");
    }

    function changeFontSize(size){
      //bodyタグにサイズを設定
      document.querySelector("html").style.fontSize = size + "%";
      //ボタンにactiveのclassを追加 or 削除
      $(fontNormalEl).removeClass("is-active");
      $(fontBigEl).removeClass("is-active");
    }
    let size = 100;

    $(fontBigEl).on("click", function () {
      changeFontSize(120);
      $(this).addClass("is-active");
      Cookies.set(cookieName, 'Big')
    });
    $(fontNormalEl).on("click", function () {
      changeFontSize(100);
      $(this).addClass("is-active");
      Cookies.set(cookieName, 'Normal')
    });
  }
}
